import {
  composeRenderProps,
  type DateFieldProps,
  DateField as DateFieldRac,
  type DateInputProps as DateInputPropsRac,
  DateInput as DateInputRac,
  type DateSegmentProps,
  DateSegment as DateSegmentRac,
  type DateValue as DateValueRac,
  type TimeFieldProps,
  TimeField as TimeFieldRac,
  type TimeValue as TimeValueRac,
} from "react-aria-components"

import { cn } from "@/modules/lib/utils"

function DateField<T extends DateValueRac>({ className, children, ...props }: DateFieldProps<T>) {
  return (
    <DateFieldRac className={composeRenderProps(className, (className) => cn(className))} {...props}>
      {children}
    </DateFieldRac>
  )
}

function TimeField<T extends TimeValueRac>({ className, children, ...props }: TimeFieldProps<T>) {
  return (
    <TimeFieldRac className={composeRenderProps(className, (className) => cn(className))} {...props}>
      {children}
    </TimeFieldRac>
  )
}

function DateSegment({ className, ...props }: DateSegmentProps) {
  return (
    <DateSegmentRac
      className={composeRenderProps(className, (className) =>
        cn(
          "data-focused:data-placeholder:text-textDefault-body data-focused:text-textDefault-body data-invalid:data-placeholder:text-textError data-placeholder:text-textOnSurface-muted data-[type=literal]:text-textOnSurface-muted inline rounded-xs p-0.5 text-textDefault-body caret-transparent outline-hidden data-disabled:cursor-not-allowed data-disabled:opacity-50 data-focused:bg-neutral-200 data-invalid:text-textError data-invalid:data-focused:bg-surface-error data-invalid:data-focused:text-white data-invalid:data-focused:data-placeholder:text-white data-[type=literal]:px-0",
          className,
        ),
      )}
      {...props}
      data-invalid
    />
  )
}

const dateInputStyle =
  "relative inline-flex h-11 w-full items-center overflow-hidden whitespace-nowrap rounded-3xl border border-borderDefault bg-surface-background px-3 py-2 text-sm shadow-xs transition-[color,box-shadow] outline-none data-focus-within:border-borderPrimary data-focus-within:ring-primary-500/50 data-focus-within:ring-[1px] data-focus-within:has-aria-invalid:ring-borderError/20 data-focus-within:has-aria-invalid:border-borderError hover:border-borderPrimary"

interface DateInputProps extends DateInputPropsRac {
  className?: string
  unstyled?: boolean
}

function DateInput({ className, unstyled = false, ...props }: Omit<DateInputProps, "children">) {
  return (
    <DateInputRac
      className={composeRenderProps(className, (className) => cn(!unstyled && dateInputStyle, className))}
      {...props}
    >
      {(segment) => <DateSegment segment={segment} />}
    </DateInputRac>
  )
}

export { DateField, DateInput, dateInputStyle, DateSegment, TimeField }
export type { DateInputProps }
